import React from 'react';

interface MobileDataItem {
  label: string;
  value: React.ReactNode;
}

interface MobileDataCardProps {
  title: string;
  items: MobileDataItem[];
  actions?: React.ReactNode;
  footer?: React.ReactNode;
  highlight?: boolean;
}

/**
 * Card genérico para visualização de dados em mobile.
 * Usa CSS definido em styles/mobile.css.
 */
export function MobileDataCard({ title, items, actions, footer, highlight }: MobileDataCardProps) {
  return (
    <div className={`mobile-data-card ${highlight ? 'shadow-sm' : ''}`}>
      <div className="mobile-card-header">
        <h6 className="mobile-card-title">{title}</h6>
        {actions && <div className="d-flex gap-2">{actions}</div>}
      </div>
      <div className="mobile-card-body">
        {items.map((item, idx) => (
          <div key={idx} className="mobile-data-row">
            <div className="mobile-data-label">{item.label}</div>
            <div className="mobile-data-value">{item.value}</div>
          </div>
        ))}
      </div>
      {footer && <div className="mobile-card-actions">{footer}</div>}
    </div>
  );
}

export default MobileDataCard;
